import { compose, setDisplayName, withProps } from 'react-recompose';
import { reduxForm } from 'redux-form/immutable.js';

import withReduxConnect from '~/views/enhancers/withReduxConnect.js';
import withReduxDataLoading from '~/views/enhancers/withReduxDataLoading.js';

import { fetchSuperPortal, patchSuperPortal } from '~/state/ducks/organizations/operations.js';
import { getInitialFormData, getOrgID } from '~/state/ducks/organizations/selectors.js';

import PortalForm from './PortalForm.js';


export default compose(
    setDisplayName('PortalEditContainer'),
    withReduxConnect({
        mapStateToProps: state => ({
            initialValues: getInitialFormData(state),
            linkToView: `../${getOrgID(state)}`,
        }),
    }),
    withReduxDataLoading({
        name: 'fetchSuperPortal',
        operation: ({ match: { params: { id } } }) => fetchSuperPortal(id),
    }),
    reduxForm({
        form: 'portal-edit',
        onSubmit: patchSuperPortal,
        enableReinitialize: true,
    }),
    withProps({
        header: 'Edit',
    }),
)(PortalForm);
